// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"640":"58027e02a201d865c594","1642":"a118a4db4cfaa015f956","4057":"6e6bf1e808e95bdecb25","5771":"d141d1ad8187d99738b9","5810":"8dfb2392d7107957a510","7471":"6423b9b898ffefeb7d1d"}[chunkId] + "";
};